import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Hero from '../../../Screens/Hero';
import {
  Content,
  HeroImage,
  Wrapper,
  Intro,
  MediaContainer,
  SubHead,
  Heading,
} from '../../../Screens/Hero/styles';
import heart from '../../../../images/Heart.svg';

export const StyledHero = styled(Hero)`
  ${Wrapper} {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    z-index: 1;

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }

    &.masterbrand {
      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
        &::before {
          position: absolute;
          content: '';
          background-image: url(${heart});
          background-position: center;
          background-size: contain;
          background-repeat: no-repeat;
          min-height: 68px;
          min-width: 48px;
          bottom: calc(0% - 2rem);
        }
      }
      @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
        &::before {
          position: absolute;
          content: '';
          min-height: 114px;
          min-width: 84px;
          bottom: calc(0% - 4rem);
        }
      }
    }
  }

  ${Content} {
    padding: ${props =>
      !!props.data?.backgroundColorWidth === false
        ? '2.5rem 1rem'
        : '2.5rem 0 0'};
    width: 100%;

    @media only screen and (min-width: 640px) {
      padding: ${props =>
        !!props.data?.backgroundColorWidth === false
          ? '2.75rem 2rem'
          : '3rem 0'};
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      width: 100%;
      min-height: 350px;
      margin: 0;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      width: 50%;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      min-height: 450px;
      padding: ${props =>
        !!props.data?.backgroundColorWidth === false
          ? '2.5rem 3.75rem 2.5rem 3.75rem'
          : '3.75rem 0 3.75rem 2rem'};
    }
  }

  ${Intro} {
    max-width: none;
    margin: -0.5rem 0 0;
  }

  ${Heading} {
    h1 {
      font-size: 1.5rem;
      line-height: 130%;

      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
        font-size: 2rem;
        line-height: 130%;
      }

      @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
        font-size: 2.5rem;
        line-height: 130%;
      }
    }
  }

  ${SubHead} {
    max-width: none;
  }

  ${MediaContainer} {
    width: 100%;
    text-align: center;
    display: flex;
    min-height: 300px;
    margin: auto;
    height: 100%;

    @media only screen and (min-width: 414px) {
      min-height: 350px;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      width: 100%;
      margin: 0 auto;
      min-height: 300px;
      height: 100%;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      width: 50%;
      min-height: 350px;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      min-height: 500px;
    }
  }

  ${HeroImage} {
    height: auto;
    margin: auto;
    padding: 0;
    position: absolute;
    bottom: -1rem;
    width: 100%;

    @media only screen and (min-width: 550px) {
      width: calc(100% * 0.75);
      left: calc(50% - (100% * 0.75 / 2));
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      width: 502px;
      bottom: -2.5rem;
      left: calc(50% - 246px);
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      width: 100%;
      bottom: -5.75rem;
      left: 0;
      right: -1rem;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      bottom: -3.75rem;
    }
  }
`;
